{
  "version": 1,
  "asset_id": "49bbab82-4c3e-4108-b8cf-8bdb00ae6871",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/49bbab82-4c3e-4108-b8cf-8bdb00ae6871/workspace-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/49bbab82-4c3e-4108-b8cf-8bdb00ae6871/workspace-1280.avif",
  "original_filename": "workspace-1280.avif",
  "size": 34800,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:27:05Z"
}
